<template>
	<div class="footer-box">
		<div id="contactUs" class="hidden-xs">
			<div class="address lattice">
				<span class="us-icon" style="width: 0.11rem;">
					<img style="width: 100%;height: 100%;" src="@/assets/img/location.png">
				</span>
				<span class="text-a">深圳市福田區車公廟工业區車公廟安華小區6棟2層、5層東側   <a href="http://beian.miit.gov.cn" target="_blank"> 粤ICP备12048189号</a></span>
				
			</div>
			<div class="cphone lattice">
				<span class="us-icon">
					<img style="width: 100%;height: 100%;" src="@/assets/img/phone.png">
				</span>
				<span class="text-a">0755-83412608</span>
			</div>
		</div>
		<div style="position: relative;height: 2.86rem;">
			<div id="swiper2" class="container-fuild">
				<div class="swiper-container banner-swiper foot-swiper">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item,index) in swiperList" :key="index">
							<img class="swiper-lazy" :data-src="item.img" alt="轮播图">
							<div class="swiper-lazy-preloader"></div>
 
						</div>
					</div>
				</div>
			</div>

			<div class="ul-box hidden-xs">
				<ul>
					<li>華瑞達概況</li>
					<li>集團簡介</li>
					<li>發展歷程</li>
					<li>公司榮譽</li>
					<li>企業文化</li>
					<li>組織架構</li>
					<li>辦公環境</li>
				</ul>
				<ul>
					<li>資質榮譽</li>
					<li>資質證書</li>
					<li>認證證書</li>
					<li>公司榮譽</li>
					<li>設計榮譽</li>
					<li>工程榮譽</li>
				</ul>
				<ul>
					<li>經典工程</li>
					<li>設計案例</li>
					<li>建築裝飾</li>
					<li>建築幕牆</li>
				</ul>
				<ul>
					<li>加入華瑞達</li>
					<li>核心優勢</li>
					<li>服務政策</li>
					<li>分支機搆</li>
				</ul>
				<ul>
					<li>新聞中心</li>
					<li>公司新聞</li>
					<li>行業新聞</li>
					
				</ul>
				<ul>
					<li>人力資源</li>
					<li>人才戰略</li>
					<li>人才隊伍</li>
					<li>教育培訓</li>
					<li>招聘資訊</li>
				</ul>
				<ul>
					<li>聯系我們</li>
					<li>聯系我們</li>
					<li>線上地圖</li>
					<li>問題留言</li>
				</ul>
			</div>
			
			<div class="code-box">
				<img class="code-img" src="@/assets/img/serverQrcode.jpg" />
				<div class="code-name">公眾號</div>
			</div>
			<div class="code-box s-box">
				<img class="code-img" src="@/assets/img/ReadQrcode.jpg" />
				<div class="code-name">服務號</div>
			</div>
			<div class="foot-info visible-xs">
				<div style="font-size: 0.37rem;font-weight: normal;color: #FFFFFF;margin-top: 3.6rem;">服務熱線</div>
				<div style="font-size: 0.39rem;font-weight: 400;color: #BA3632;margin-top: .23rem;">0755-83412608</div>
				<div style="font-size: 0.37rem;font-weight: normal;color: #FFFFFF;margin-top: 0.36rem;">地址</div>
				<div style="font-size: 0.39rem;font-weight: 400;color: #BA3632;margin-top: .23rem;">
					深圳市福田區車公廟工业區車公廟安華小區6棟2層、5層東側   </div>
			</div>
		</div>
	</div>

</template>
<script>
	import Swiper from "swiper";
	export default {
		name: "Footer",
		props: ['swiperList'],
		data() {
			return {

			};
		},
		mounted() {
			var mySwiper2 = new Swiper(".foot-swiper", {
				loop: true, // 循环模式选项
				effect: 'creative',
				creativeEffect: {
					prev: {
						shadow: true,
						origin: "left center",
						translate: ["-5%", 0, -200],
						rotate: [0, 100, 0],
					},
					next: {
						origin: "right center",
						translate: ["5%", 0, -200],
						rotate: [0, -100, 0],
					},
				},
				autoplay: {
					delay: 3000,
					stopOnLastSlide: false,
					disableOnInteraction: false
				},
				lazy: {
					loadPrevNext: true
				},
				observer: true, //修改swiper自己或子元素时，自动初始化swiper
				observeParents: true //修改swiper的父元素时，自动初始化swiper
			});
		}
	};
</script>
<style scoped>
	/* 轮播图 */
	#swiper2 {
		width: 100%;
		z-index: 0;
		height: 2.86rem;
		position: absolute;
		top: 0;
		left: 0;
	}

	#swiper2 .banner-swiper {
		width: 100%;
		height: 100%;
	}

	#swiper2 .banner-swiper .swiper-slide img {
		width: 100%;
		height: 100%;
	}

	#swiper2 .banner-swiper .swiper-slide {
		position: relative;
	}

	#swiper2 .banner-swiper .swiper-slide-title {
		position: absolute;
		top: 0px;
		left: 0;
		z-index: 999999999;
		width: 100%;
		height: 100%;
		color: #fff;
		background: rgba(51, 51, 51, 0.534);
		text-align: center;
		line-height: 0.42rem;
	}

	#swiper2 .banner-swiper .swiper-slide-title>h1 {
		font-size: 0.35rem;
		margin-top: 16%;
		letter-spacing: 0.04rem;
	}

	#swiper2 .banner-swiper .swiper-slide-title>p {
		font-size: 0.11rem;
		margin-top: 1%;
		letter-spacing: 2px;
		font-weight: 500;
		color: rgba(255, 255, 255, 0.5);
		font-family: Arial, Helvetica, sans-serif;
	}

	#contactUs {
		color: #6E6E6E;
		height: 0.47rem;
		display: flex;
		justify-content: space-evenly;
		align-items: center;
		z-index: 1;
		width: 100%;
		border: 0.01rem dotted rgb(136, 136, 136);
		background-color: rgb(229, 229, 229);
		border-bottom: none;
	}

	#contactUs .us-icon {
		width: 0.16rem;
		height: 0.16rem;
		margin-right: .06rem;
		display: block;
	}

	#contactUs .lattice {
		display: flex;
		align-items: center;
	}

	#contactUs .address .text-a {
		font-size: 0.11rem;
		font-family: Source Han Sans CN;
		font-weight: 500;
		letter-spacing: 0.015rem;
	}

	#contactUs .cphone .text-a {
		font-size: 0.13rem;
		font-family: Impact;
		font-weight: 400;
		letter-spacing: 0.015rem;
	}

	.ul-box {
		position: absolute;
		z-index: 99;
		display: flex;
		justify-content: space-between;
		width: 6rem;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}

	.ul-box ul {
		color: #fff;
		list-style: none;
	}

	.ul-box ul li {
		margin-bottom: 0.06rem;

		font-size: 0.11rem;
		text-align: center;
		letter-spacing: 0.02rem;
	}

	.ul-box ul li:nth-of-type(1) {
		font-weight: bold;
		margin-bottom: 0.15rem;
	}

	.ul-box ul li:not(:nth-of-type(1)):hover {
		color: rgb(184, 49, 45);
		cursor: pointer;
	}

	.code-box {
		position: absolute;
		top: 0.6rem;
		right: 0.61rem;
		text-align: center;
	}

	.s-box {
		top: 1.62rem;
	}

	.code-box .code-img {
		width: .76rem;
		height: .76rem;
	}

	.code-box .code-name {
		margin-top: 0.03rem;
		font-size: 0.11rem;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #FFFFFF;
		letter-spacing: 0.01rem;
	}

	@media screen and (max-width: 768px) {
		#swiper2 {
			height: 7.33rem;
		}

		.code-box {
			position: absolute;
			top: 0.88rem;
			left: 1.99rem;
			text-align: center;
			width: 1.94rem;
		}

		.code-box .code-img {
			width: 1.94rem;
			height: 1.94rem;
		}

		.code-box .code-name {
			margin-top: 0.19rem;
			font-size: 0.28rem;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #FFFFFF;
		}

		.s-box {
			left: unset;
			right: 1.99rem !important;
		}

		.foot-info {
			position: absolute;
			z-index: 99;
			justify-content: center;
			flex-direction: column;
			align-items: center;
			width: 100%;
      text-align: center;
		}
		.footer-box{
			height: 7.33rem;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue